export default "__VITE_ASSET__BwH0Ejxn__"